if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // Open the drawer NOW rather than when the response lands. /cart/add.js takes ~0.5s against
      // Shopify, and the drawer used to sit closed for all of it — the click felt unanswered.
      // It opens on the previous cart contents (which are correct except for the line being added)
      // and gets `is-updating` so the item list can show it's refreshing; renderContents swaps the
      // real contents in a moment later, in place, with the drawer already on screen.
      //
      // ONLY when the cart already has something in it. That's what makes the early open worth it:
      // there are real contents to look at while the request finishes. Adding the FIRST item has
      // nothing to show, so opening early buys an empty panel for half a second — worse than the
      // wait it removes. In that one case we hold off and open on the response, with the item in it.
      //
      // Skipped for cart-notification (a popup, not a panel) and inside quick-add, where the modal
      // owns the transition and opening underneath it would fight for the same space.
      this.openedEagerly = false;
      if (
        this.cart &&
        typeof this.cart.open === 'function' &&
        this.cart.tagName === 'CART-DRAWER' &&
        !this.closest('quick-add-modal') &&
        !this.cart.classList.contains('active') &&
        !this.cart.classList.contains('is-empty')
      ) {
        this.openedEagerly = true;
        this.cart.classList.add('is-updating');
        this.cart.open(submitButton);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            // Nothing was added, so the drawer we opened on spec has no business being up — and
            // it would sit over the error message explaining why. Only close what WE opened.
            if (this.openedEagerly && typeof this.cart.close === 'function') this.cart.close();

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if ( document.querySelector('.quick-options-drawer.open') != null ) {
            document.querySelector('.quick-options-drawer.open').classList.remove('open');
            document.querySelector('body').classList.remove('quick-options-open');
          }


          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart) this.cart.classList.remove('is-updating');
          this.submitButton.classList.remove('loading');
          // `is-empty` is cleared by renderContents now — single owner, see cart-drawer.js.
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
